export const useWordGoogleFormats = () => {
  return [
    "application/vnd.google-apps.document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
};
